import React, { createContext, useState } from "react";

export const FormContext = createContext({
  isDirty: false,
  formValues: {},
  setValues: (values) => {},
  setFunctions: (functions) => {},
  setDirty: () => {},
  notDirty: () => {},
  getDirtyValue: () => {},
  functions: {},
  clearFormContext: () => {}
});

const FormContextProvider = props => {
  const [isFormDirty, setFormDirty] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [functions, setFunctions] = useState({
  });

  const dirtyFormHandler = () => {
    setFormDirty(true);
  };

  const notDirtyHandler = () => {
    setFormDirty(false);
  };

  const formValuesHandler = (values) => {
    // final-form will preserve null values, but we want them to be overriden by initialValues downstream
    // react-final-form docs appear incorrect, form initialValues take priority over field initialValue
    // initialValues are used to populate form values
    // https://github.com/final-form/final-form/blob/master/src/FinalForm.js#L202
    // field initialValue will not be set if value already exists in form
    // https://github.com/final-form/final-form/blob/master/src/FinalForm.js#L860
    // set null values to undefined so downstream fields can properly set initialValue
    // this was introduced to support the endTime field value, which will be null in some cases but we need to initially set it to new Date(startTime + 10 minute)
    const newValues = {};
    const keys = Object.keys(values);

    for (const key of keys) {
      newValues[key] = values[key] === null ? undefined : values[key];
    }

    setFormValues(newValues);
  }

  const onSetFunctiontHandler = (funcs) => {
    setFunctions({
      ...funcs
    })
  }

  const clearFormContext = () => {
    notDirtyHandler();
    setFormValues({});
    setFunctions({});
  }

  const getValue = () => {
    return isFormDirty.toString();
  }

  return (
    <FormContext.Provider
      value={{
        isDirty: isFormDirty,
        formValues: formValues,
        setValues: formValuesHandler,
        setDirty: dirtyFormHandler,
        notDirty: notDirtyHandler,
        getDirtyValue: getValue,
        functions,
        setFunctions: onSetFunctiontHandler,
        clearFormContext
      }}
    >
      {props.children}
    </FormContext.Provider>
  );
};

export default FormContextProvider;



// WEBPACK FOOTER //
// ./src/context/form-context.js